import React, { useState, useEffect } from 'react';

const VonScalperTestimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Alex",
      role: "Quantitative Trader",
      company: "Goldman Sachs Alumni",
      avatar: "M",
      content: "VON SCALPER's multi-timeframe approach is genuinely impressive. The pattern recognition accuracy rivals institutional-grade systems I've used. The risk management alone has saved me thousands in drawdown.",
      rating: 5,
      metrics: { roi: "+187%", trades: "2,341", months: "14" }
    },
    {
      id: 2,
      name: "Sarah",
      role: "Prop Trader",
      company: "FTMO Funded",
      avatar: "S",
      content: "As someone trading with funded capital, risk management is everything. VON SCALPER's adaptive ML framework has consistently kept me within drawdown limits while maximizing profits. Game-changer.",
      rating: 5,
      metrics: { roi: "+94%", trades: "1,827", months: "8" }
    },
    {
      id: 3,
      name: "Kim",
      role: "Crypto Specialist",
      company: "Independent Trader",
      avatar: "D",
      content: "The 24/7 crypto market adaptation is phenomenal. VON SCALPER handles Bitcoin volatility better than any system I've tested. The Telegram notifications keep me informed without overwhelming me.",
      rating: 5,
      metrics: { roi: "+312%", trades: "3,156", months: "11" }
    },
    {
      id: 4,
      name: "Chris",
      role: "Forex Scalper",
      company: "Professional Trader",
      avatar: "A",
      content: "I've been scalping for 7 years manually. VON SCALPER captures opportunities I would miss and executes with precision I can't match. The ICT pattern recognition is incredibly sophisticated.",
      rating: 5,
      metrics: { roi: "+156%", trades: "4,203", months: "18" }
    },
    {
      id: 5,
      name: "James",
      role: "Portfolio Manager",
      company: "Hedge Fund",
      avatar: "J",
      content: "We tested VON SCALPER against our internal algorithms. The consistency across different market regimes impressed our entire quant team. Now it's part of our systematic trading arsenal.",
      rating: 5,
      metrics: { roi: "+89%", trades: "1,934", months: "6" }
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="py-24 bg-gradient-to-br from-white via-slate-50 to-purple-50" id="testimonials">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="h-0.5 w-12 bg-gradient-to-r from-cyan-500 to-purple-500 mr-4"></div>
            <span className="py-2 px-4 rounded-full text-purple-700 bg-purple-100 font-semibold text-sm border border-purple-200">TESTIMONIALS</span>
            <div className="h-0.5 w-12 bg-gradient-to-r from-purple-500 to-cyan-500 ml-4"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-slate-800 to-purple-800 bg-clip-text text-transparent">
            What Professional Traders Say
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Discover how VON SCALPER has transformed trading outcomes for professionals 
            across different markets and trading styles.
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div className="max-w-6xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden">
            {/* Background Effects */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-600 rounded-full mix-blend-multiply opacity-10 filter blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600 rounded-full mix-blend-multiply opacity-10 filter blur-3xl"></div>
            
            <div className="relative z-10">
              <div className="grid lg:grid-cols-3 gap-12 items-center">
                {/* Testimonial Content */}
                <div className="lg:col-span-2 space-y-8">
                  <div className="flex items-center space-x-2 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  
                  <blockquote className="text-2xl md:text-3xl font-light leading-relaxed text-slate-200">
                    "{testimonials[currentTestimonial].content}"
                  </blockquote>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-cyan-600 to-purple-600 rounded-full flex items-center justify-center text-2xl font-bold">
                      {testimonials[currentTestimonial].avatar}
                    </div>
                    <div>
                      <div className="text-xl font-bold text-white">{testimonials[currentTestimonial].name}</div>
                      <div className="text-cyan-300 font-medium">{testimonials[currentTestimonial].role}</div>
                      <div className="text-slate-400 text-sm">{testimonials[currentTestimonial].company}</div>
                    </div>
                  </div>
                </div>

                {/* Performance Metrics */}
                <div className="space-y-6">
                  <h4 className="text-xl font-bold text-cyan-300">Performance Metrics</h4>
                  <div className="space-y-4">
                    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                      <div className="text-3xl font-bold text-green-400">{testimonials[currentTestimonial].metrics.roi}</div>
                      <div className="text-slate-300 text-sm">Total ROI</div>
                    </div>
                    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                      <div className="text-3xl font-bold text-purple-400">{testimonials[currentTestimonial].metrics.trades}</div>
                      <div className="text-slate-300 text-sm">Total Trades</div>
                    </div>
                    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                      <div className="text-3xl font-bold text-cyan-400">{testimonials[currentTestimonial].metrics.months}</div>
                      <div className="text-slate-300 text-sm">Months Trading</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="flex justify-center space-x-3 mt-12">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-all duration-300 ${
                      index === currentTestimonial ? 'bg-cyan-400 w-8' : 'bg-white/30 hover:bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <div key={testimonial.id} className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200 hover:shadow-xl transition-shadow">
              <div className="flex items-center space-x-2 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              
              <p className="text-slate-600 mb-6 leading-relaxed italic">
                "{testimonial.content.substring(0, 120)}..."
              </p>
              
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-bold text-slate-800">{testimonial.name}</div>
                  <div className="text-purple-600 text-sm">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 p-6 bg-white rounded-2xl shadow-lg border border-slate-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-slate-800">500+</div>
              <div className="text-slate-600 text-sm">Active Traders</div>
            </div>
            <div className="w-px h-12 bg-slate-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-slate-800">4.9/5</div>
              <div className="text-slate-600 text-sm">Average Rating</div>
            </div>
            <div className="w-px h-12 bg-slate-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-slate-800">24/7</div>
              <div className="text-slate-600 text-sm">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VonScalperTestimonials;